__turbopack_context__.v({
  "floating": "StudioHero-module-scss-module__OD11Ba__floating",
  "hero": "StudioHero-module-scss-module__OD11Ba__hero",
  "hero__content": "StudioHero-module-scss-module__OD11Ba__hero__content",
  "hero__first-part": "StudioHero-module-scss-module__OD11Ba__hero__first-part",
  "hero__second-part": "StudioHero-module-scss-module__OD11Ba__hero__second-part",
  "rotate": "StudioHero-module-scss-module__OD11Ba__rotate",
  "slowRotate": "StudioHero-module-scss-module__OD11Ba__slowRotate",
  "studio-description": "StudioHero-module-scss-module__OD11Ba__studio-description",
});
